// Оформление заказа и «Мои заказы» (docs/04-api-contract.md §3, docs/07-miniapp-ux.md §2.5-2.7).
import type { ApiResponse, components } from "@shopkit/shared";

import { apiRequest } from "./client";

export type Order = ApiResponse<"getMyOrder">;
export type OrderListItem = components["schemas"]["OrderListItem"];
export type OrderList = ApiResponse<"listMyOrders">;
export type OrderCreateInput = components["schemas"]["OrderCreateInput"];
export type OrderCreateSummary = components["schemas"]["OrderCreateSummary"];

/**
 * createOrder оформляет заказ из текущей корзины покупателя. idempotencyKey
 * уходит заголовком Idempotency-Key — повторный вызов с тем же ключом
 * возвращает уже созданный заказ вместо второго (docs/04-api-contract.md §3).
 * Бросает ApiError: 422 ошибки полей, 409 пустая корзина/мин. сумма/магазин недоступен.
 */
export function createOrder(input: OrderCreateInput, idempotencyKey: string): Promise<OrderCreateSummary> {
  return apiRequest<{ order: OrderCreateSummary }>("/api/v1/orders", {
    method: "POST",
    headers: { "Content-Type": "application/json", "Idempotency-Key": idempotencyKey },
    body: JSON.stringify(input),
  }).then((response) => response.order);
}

/** listMyOrders — страница истории заказов покупателя. Бросает ApiError. */
export function listMyOrders(cursor: string | null, signal?: AbortSignal): Promise<OrderList> {
  const params = new URLSearchParams({ limit: "10" });
  if (cursor) params.set("cursor", cursor);
  return apiRequest<OrderList>(`/api/v1/orders?${params.toString()}`, { signal });
}

/** getMyOrder — карточка заказа покупателя. Бросает ApiError: 404. */
export function getMyOrder(orderId: string, signal?: AbortSignal): Promise<Order> {
  return apiRequest<Order>(`/api/v1/orders/${orderId}`, { signal });
}
